import {
	WebAnalysisPage,
	WebDonorPagePage,
	WebLandingPage,
	WebNationalPagePage,
	WebStatePagePage
} from './web-components';
import r2wc from '@r2wc/react-to-web-component';
import { WebComponentWrapper } from './web-components/WebComponentWrapper';
import { LandingPage } from './components/Pages/LandingPage';
import { StateViewPage } from './components/Pages/StateViewPage';
import { NationalViewPage } from './components/Pages/NationalViewPage';
import { DonorPage } from './components/Pages/DonorPage';
import AnalysisPage from './components/Pages/AnalysisPage';

// Primary registration (future-facing, defaults to 2026)
customElements.define('cawp-wmp-landing', WebLandingPage);
customElements.define('cawp-wmp-state', WebStatePagePage);
customElements.define('cawp-wmp-national', WebNationalPagePage);
customElements.define('cawp-wmp-donor', WebDonorPagePage);
customElements.define('cawp-wmp-analysis', WebAnalysisPage);

// Backwards compatibility (2024 names) - create new wrappers with hardcoded year=2024
const WrappedLandingPage2024 = () => (
	<WebComponentWrapper year={2024}>
		<LandingPage />
	</WebComponentWrapper>
);

const WrappedStatePagePage2024 = () => (
	<WebComponentWrapper year={2024} dataFormProvider>
		<StateViewPage />
	</WebComponentWrapper>
);

const WrappedNationalPagePage2024 = () => (
	<WebComponentWrapper year={2024} dataFormProvider>
		<NationalViewPage />
	</WebComponentWrapper>
);

const WrappedDonorPagePage2024 = () => (
	<WebComponentWrapper year={2024} dataFormProvider>
		<DonorPage />
	</WebComponentWrapper>
);

const WrappedAnalysisPage2024 = () => (
	<WebComponentWrapper year={2024}>
		<AnalysisPage />
	</WebComponentWrapper>
);

export const WebLandingPage2024 = r2wc(WrappedLandingPage2024);
export const WebStatePagePage2024 = r2wc(WrappedStatePagePage2024);
export const WebNationalPagePage2024 = r2wc(WrappedNationalPagePage2024);
export const WebDonorPagePage2024 = r2wc(WrappedDonorPagePage2024);
export const WebAnalysisPage2024 = r2wc(WrappedAnalysisPage2024);

customElements.define('cawp-wmp2024-landing', WebLandingPage2024);
customElements.define('cawp-wmp2024-state', WebStatePagePage2024);
customElements.define('cawp-wmp2024-national', WebNationalPagePage2024);
customElements.define('cawp-wmp2024-donor', WebDonorPagePage2024);
customElements.define('cawp-wmp2024-analysis', WebAnalysisPage2024);
